module.exports = require("@babel/runtime-corejs3/core-js-stable/promise");